import {fieldChange} from '../events'
import withSnowplowLifecycle from './withSnowplowLifecycle'

const withFieldChangeEvent = (WrappedComponent, options = null) => withSnowplowLifecycle(WrappedComponent, fieldChange, options)

export default withFieldChangeEvent
